import React from 'react';
import { Col, Row, Typography, List } from 'antd';
import { useQuery } from '@apollo/client';
import { queries } from '../../graphql/graphql';
import { DirectoriesValuesByIdsResponse } from '../../types/directory';
import { Loader } from '../UI/Loader';

const { Text } = Typography;

interface AvailableAreaProps {
  available: {
    cities: string[];
    states: string[];
    counties: string[];
  };
}

const DirectoryList = ({
  label,
  data,
}: {
  label: string;
  data: DirectoriesValuesByIdsResponse;
}) => {
  return (
    <Col span={24}>
      <Text strong>{label}:</Text>
      <List
        dataSource={data.directoriesValuesByIds}
        renderItem={state => <List.Item key={state.id}>{state.name}</List.Item>}
      />
    </Col>
  );
};

export const AvailableArea = ({ available }: AvailableAreaProps) => {
  const { loading: citiesLoading, data: citiesData } = useQuery<DirectoriesValuesByIdsResponse>(
    queries.directories.DIRECTORIES_VALUES_BY_IDS,
    {
      variables: { ids: available.states },
      skip: !available.cities || available.cities.length === 0,
    }
  );

  const { loading: countiesLoading, data: countiesData } = useQuery<DirectoriesValuesByIdsResponse>(
    queries.directories.DIRECTORIES_VALUES_BY_IDS,
    {
      variables: { ids: available.counties },
      skip: !available.counties || available.counties.length === 0,
    }
  );

  const { loading: statesLoading, data: statesData } = useQuery<DirectoriesValuesByIdsResponse>(
    queries.directories.DIRECTORIES_VALUES_BY_IDS,
    {
      variables: { ids: available.states },
      skip: !available.states || available.states.length === 0,
    }
  );

  if (citiesLoading || countiesLoading || statesLoading) return <Loader />;

  return (
    <Row gutter={[16, 16]}>
      {statesData && statesData.directoriesValuesByIds.length > 0 ? (
        <DirectoryList label="States" data={statesData} />
      ) : (
        <Col span={24}>
          <Text>No states selected</Text>
        </Col>
      )}
      {citiesData && citiesData.directoriesValuesByIds.length > 0 ? (
        <DirectoryList label="Cities" data={citiesData} />
      ) : (
        <Col span={24}>
          <Text>No cities selected</Text>
        </Col>
      )}
      {countiesData && countiesData.directoriesValuesByIds.length > 0 ? (
        <DirectoryList label="Counties" data={countiesData} />
      ) : (
        <Col span={24}>
          <Text>No counties selected</Text>
        </Col>
      )}
    </Row>
  );
};
